import React from 'react';
import loadable from '@loadable/component';
import { videosOnEnterSaga, liveAdminOnEnterSaga, liveOnEnterSaga } from 'features/Videos/sagas/live.onenter.saga';
import { CP_LIVE_PARTNER_ALIAS } from 'constants/video';

const CollectionContainer = loadable(() => import('./CollectionContainer'));
const OnDemandContainer = loadable(() => import('./OnDemandContainer'));
const PartnerVideosContainer = loadable(() => import('./PartnerVideosContainer'));
const UpcomingLiveContainer = loadable(() => import('./UpcomingLiveContainer'));
const VideoDetailContainer = loadable(() => import('features/VideoDetail/VideoDetailContainer'));
const VideosContainer = loadable(() => import('./VideosContainer'));

export const VideosRoute = (store, client) => ({
  path: '/videos',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(videosOnEnterSaga, client, nextState, replaceState, '/')
      .toPromise()
      .then(cb),

  indexRoute: {
    component: props => <VideosContainer {...props} />,
    onEnter: (nextState, replaceState, cb) =>
      store
        .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState, 'videos/partners')
        .toPromise()
        .then(cb),
  },

  childRoutes: [
    {
      path: 'upcoming',
      component: props => <UpcomingLiveContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: 'on-demand',
      component: props => <OnDemandContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: 'partners',
      component: props => <PartnerVideosContainer {...props} />,
    },
    {
      path: 'live',
      component: props => <VideosContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: 'live/:liveAlias',
      component: props => <VideoDetailContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: 'live-admin/:adminAlias',
      component: props => <VideoDetailContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveAdminOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: `${CP_LIVE_PARTNER_ALIAS}/:ghostAlias`,
      component: props => <VideoDetailContainer {...props} />,
      onEnter: (nextState, replaceState, cb) =>
        store
          .runSagaOnce(liveOnEnterSaga, client, nextState, replaceState)
          .toPromise()
          .then(cb),
    },
    {
      path: 'collection/:collectionId*',
      component: props => <CollectionContainer {...props} />,
    },
    {
      path: ':partnerAlias/:videoAlias',
      component: props => <VideoDetailContainer {...props} />,
    },
  ],
});
